import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import HavnsLogo from "../components/HavnsLogo";
import Footer from "../components/Footer";

const Privacy = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#FBF9F7]">
      {/* Navigation */}
      <nav className="fixed top-0 left-0 right-0 z-50 bg-[#FBF9F7]/90 backdrop-blur-md">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 flex items-center justify-between h-20">
          <HavnsLogo className="text-2xl" linkTo="/" />
        </div>
      </nav>

      {/* Content */}
      <section className="pt-32 pb-24">
        <div className="max-w-3xl mx-auto px-6 lg:px-12">
          <button
            onClick={() => navigate(-1)}
            className="flex items-center gap-2 text-[#666] hover:text-[#1A1A1A] mb-12 transition-colors"
          >
            <ArrowLeft className="w-4 h-4" />
            <span>Back</span>
          </button>

          <h1 className="font-serif text-4xl sm:text-5xl text-[#1A1A1A] mb-4">
            Privacy Policy
          </h1>
          <p className="text-[#999] mb-12">Last updated: {new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}</p>

          <div className="prose prose-lg max-w-none space-y-8">
            <section>
              <h2 className="font-serif text-2xl text-[#1A1A1A] mb-4">Information We Collect</h2>
              <p className="text-[#666] leading-relaxed">
                We collect information you provide directly, including your name, email, 
                profile information, and Aadhaar verification data (processed securely 
                through our KYC partner). We also collect usage data to improve our services.
              </p>
            </section>

            <section>
              <h2 className="font-serif text-2xl text-[#1A1A1A] mb-4">How We Use Your Information</h2>
              <ul className="space-y-2 text-[#666]">
                <li>To verify your identity and maintain community safety</li>
                <li>To facilitate connections with other verified members</li>
                <li>To process payments and manage subscriptions</li>
                <li>To communicate important updates about our service</li>
                <li>To improve and personalize your experience</li>
              </ul>
            </section>

            <section>
              <h2 className="font-serif text-2xl text-[#1A1A1A] mb-4">Data Security</h2>
              <p className="text-[#666] leading-relaxed">
                Your data is encrypted in transit and at rest. Aadhaar verification data 
                is processed by certified partners and we do not store raw Aadhaar numbers. 
                We implement industry-standard security measures to protect your information.
              </p>
            </section>

            <section>
              <h2 className="font-serif text-2xl text-[#1A1A1A] mb-4">Your Rights</h2>
              <p className="text-[#666] leading-relaxed">
                You can access, update, or delete your personal information at any time 
                through your account settings. You may also request a complete data export 
                or account deletion by contacting our support team.
              </p>
            </section>

            <section>
              <h2 className="font-serif text-2xl text-[#1A1A1A] mb-4">Contact Us</h2>
              <p className="text-[#666] leading-relaxed">
                For privacy-related inquiries, please contact us at privacy@havns.co
              </p>
            </section>
          </div>
        </div>
      </section>

      <Footer bgColor="bg-white" />
    </div>
  );
};

export default Privacy;
